const About = () => {
  return (
    <section className="about">
      <h3>About</h3>
    </section>
  )
}

export default About
